import React, { useState, useEffect } from "react";
import FloatingCta from "./FloatingNotification";
import { db } from "../../config/FirebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";
import "./FloatingNotificationAdmin.css";
import { Link } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { whatsappLink } from "../../config/FirebaseConfig";
import { FaLongArrowAltRight } from "react-icons/fa";

const FloatingNotificationAdmin = () => {
  const navigate = useNavigate();
  const [notification, setNotification] = useState({
    title: "",
    subtitle: "",
    ctaText: "",
    isActive: true,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const docRef = doc(db, "config", "notification");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setNotification({
            title: docSnap.data().title || "",
            subtitle: docSnap.data().subtitle || "",
            ctaText: docSnap.data().ctaText || "",
            isActive:
              docSnap.data().isActive !== undefined
                ? true
                : true,
          });
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNotification((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const saveSettings = async () => {
    try {
      await setDoc(doc(db, "config", "notification"), notification);
      alert("Configurações salvas com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar configurações:", error);
      alert("Erro ao salvar configurações");
    }
  };

  return (
    <div className="floating-notification-admin">
      <button onClick={() => navigate("/admin")} className="back-button">
        <AiOutlineArrowLeft /> Voltar
      </button>

      <h2>Configurações da Notificação Flutuante</h2>

      <div className="form-group">
        <label>
          Título:
          <input
            type="text"
            name="title"
            value={notification.title}
            onChange={handleChange}
          />
        </label>
      </div>

      <div className="form-group">
        <label>
          Subtítulo:
          <input
            type="text"
            name="subtitle"
            value={notification.subtitle}
            onChange={handleChange}
          />
        </label>
      </div>

      <div className="form-group">
        <label>
          Texto do botão:
          <input
            type="text"
            name="ctaText"
            value={notification.ctaText}
            onChange={handleChange}
          />
        </label>
      </div>

      {/* <div className="form-group checkbox-group">
        <label>
          <input
            type="checkbox"
            name="isActive"
            checked={notification.isActive}
            onChange={handleChange}
          />
          Notificação ativa
        </label>
      </div> */}

      {isLoading ? (
        <p className="loading">Carregando configurações...</p>
      ) : (
        <>
          <h3>Pré-visualização:</h3>
          <div className="preview-container">
            <div className="preview-content">
              <div
                style={{
                  position: "fixed",
                  // bottom: isVisible ? "30px" : "-100px",
                  left: "0",
                  right: "0",
                  zIndex: 1000,
                  transition: "bottom 0.3s ease",
                  padding: "0 20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    background:
                      "linear-gradient(269.52deg, #E32285 28.23%, #9747FF 79.08%)",
                    color: "white",
                    padding: "25px 20px",
                    borderRadius: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    maxWidth: "1200px",
                    width: "100%",
                    position: "relative", // Added for absolute positioning of close button
                  }}
                >
                  {/* Close button positioned exactly as in the reference image */}
                  <button
                    style={{
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      background: "white",
                      border: "1px solid #e2e8f0",
                      borderRadius: "50%",
                      width: "24px",
                      height: "24px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                      padding: 0,
                      zIndex: 1,
                    }}
                  >
                    <IoMdClose size={14} color="#4a5568" />
                  </button>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        marginBottom: "2px",
                      }}
                    >
                      {notification.subtitle}
                    </span>
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {notification.title}
                    </span>
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Link
                      // to=""
                      style={{
                        background: "white",
                        color: "#b01a67",
                        padding: "8px 16px",
                        borderRadius: "20px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        textDecoration: "none",
                        fontSize: "14px",
                      }}
                    >
                      {notification.ctaText}
                      <FaLongArrowAltRight style={{ marginLeft: "8px" }} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button onClick={saveSettings} className="save-button">
            Salvar Configurações
          </button>
        </>
      )}
    </div>
  );
};

export default FloatingNotificationAdmin;
